import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Consts } from "../../pages/consts";
import { intakeDosageUnits, intakeFrequencyUnits } from "../../../resources/json/jsons";
import {useState} from "react";
import {getInputFocusStyle} from "../../pages/utils";

const IntakesFrequencyAndDosageUnit = ({selectedDrug, setSelectedDrug}) => {
  const { t } = useTranslation();
  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

  const handleChangingDosageUnit = (value) => {
    const newIntakes = selectedDrug?.intakes?.map(intake => ({...intake, dosageUnit: value})) || [];
    setSelectedDrug({...selectedDrug, intakes: newIntakes, dosageUnit: value});
  }

  return (
    <section className="intakes-frequency-dosage-unit">
      <div className="intakes-frequency-dosage-unit__grid">
        <div className="intakes-frequency-dosage-unit__card">
          <label
            className="intakes-frequency-dosage-unit__label"
            htmlFor={Consts.FREQUENCY_UNIT}
          >
            {t("frequency")}*
          </label>
          <div className="intakes-frequency-dosage-unit__frequency-row">
            <span className="intakes-frequency-dosage-unit__prefix">
              {t("every")?.toLowerCase()}
            </span>
            <input
              id={`${Consts.FREQUENCY_UNIT}-value`}
              value={selectedDrug?.frequency}
              type={Consts.NUMBER}
              min="0"
              onFocus={() => setIsTextFieldFocused(true)}
              onBlur={() => setIsTextFieldFocused(false)}
              className="form-input intakes-frequency-dosage-unit__number-input"
              onChange={(e) => setSelectedDrug({...selectedDrug, frequency: e.target.value})}
              style={getInputFocusStyle(isTextFieldFocused)}
            />
            <div className="intakes-frequency-dosage-unit__select-wrap intakes-frequency-dosage-unit__select-wrap--frequency">
              <Select
                id={Consts.FREQUENCY_UNIT}
                options={intakeFrequencyUnits}
                value={intakeFrequencyUnits?.filter(
                  (option) => option?.value === selectedDrug?.frequencyUnit,
                )}
                formatOptionLabel={(o) => t(o?.label)}
                onChange={({ value }) => setSelectedDrug({...selectedDrug, frequencyUnit: value})}
                placeholder={t("select")}
                className="custom-select intakes-frequency-dosage-unit__select"
                classNamePrefix="custom-select"
                isSearchable={false}
              />
            </div>
          </div>
        </div>

        <div className="intakes-frequency-dosage-unit__card">
          <label
            className="intakes-frequency-dosage-unit__label"
            htmlFor={Consts.STRENGTH_UNIT}
          >
            {t("dosage_unit")}*
          </label>
          <div className="intakes-frequency-dosage-unit__select-wrap intakes-frequency-dosage-unit__select-wrap--dosage">
            <Select
              id={Consts.STRENGTH_UNIT}
              value={intakeDosageUnits?.filter(
                (option) => option?.value === selectedDrug?.dosageUnit,
              )}
              options={intakeDosageUnits}
              formatOptionLabel={(o) => t(o?.label)}
              name={Consts.STRENGTH_UNIT}
              onChange={({ value }) => handleChangingDosageUnit(value)}
              placeholder={t("select")}
              className="custom-select intakes-frequency-dosage-unit__select"
              classNamePrefix="custom-select"
              isSearchable={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntakesFrequencyAndDosageUnit;
